import { Typography } from "@mui/material";

type Props = {
  required?: boolean;
};

export const DynamicFormRequiredLabel = (props: Props) => {
  if (!props.required) return null;
  return (
    <Typography
      color="warning"
      variant="smallLabel"
      component="span"
      sx={{
        fontSize: "12px !important",
        opacity: 0.7,
        marginTop: "-2px",
        marginBottom: "0px",
        "@media (max-width: 899px)": {
          fontSize: "12px !important",
        },
        // display: "inline",
      }}
    >
      * Påkrævet
    </Typography>
  );
};
